export function setGuest(state) {
	state.guest = true;
}

export function login(state, emailAddress) {
	state.loggedIn = true;
	state.guest = false;
	state.email = emailAddress;
}

export function setApplicantType(state, applicantType) {
	state.applicantType = applicantType;
}

export function setStudentType(state, studentType) {
	state.studentType = studentType;
}

export function setInstitutions(state, institutions) {
	state.institutions = institutions;
}

export function setUserType(state, userType) {
	state.userType = userType;
}

export function setEmail(state, email) {
	state.email = email;
}
